var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},[(_vm.elementIconIsLocal)?_c('Icon',{attrs:{"icon":_vm.elementIcon,"size":_vm.size}}):_c('div',{style:({ width: `${_vm.size}px`, height: `${_vm.size}px`, display: 'flex' }),domProps:{"innerHTML":_vm._s(_vm.elementIcon)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }